module.exports = {"data":{"data":{"code":"123"},"result":1,"message":""}}


//////////////////
// WEBPACK FOOTER
// ./src/api/getMyLink.json
// module id = sx2+
// module chunks = 1